import { GzDashboardTitleWithFeedBackToolbarWebComponent } from './component/GzDashboardTitleWithFeedBackToolbarWebComponent';

export { GzDashboardTitleWithFeedBackToolbarWebComponent };
